// extracted by mini-css-extract-plugin
module.exports = {"Container":"EmptyRemixes_Container__MMn7t","Button":"EmptyRemixes_Button___LCz0","Robot":"EmptyRemixes_Robot__YwW3R"};